import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "../../constants";

// Selector del tipo de persona del contratista, compartido por las dos
// entradas de creación: /contracts/new (natural) y /contracts/legal/new
// (jurídica). Se mantiene visible en ambas para poder corregir la elección;
// como cada tipo vive en un formulario distinto, cambiarlo es navegar y lo
// diligenciado en el formulario actual se pierde. El tipo NO es modificable
// después de creado, así que solo se monta en los formularios nuevos.

const ContractPersonTypeToggle = ({ value }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.value);

  // Crear naturales y crear jurídicos son permisos distintos, así que el
  // selector solo ofrece lo que el usuario puede crear. Si solo puede una clase
  // no hay nada que elegir y no se muestra: dejarlo visible era una puerta a
  // /contracts/legal/new para quien no tiene contract_legal.create.
  const canCreateNatural = !!user?.permissions?.includes(PERMISSIONS.CONTRACT.CREATE);
  const canCreateLegal = !!user?.permissions?.includes(PERMISSIONS.CONTRACT_LEGAL.CREATE);
  if (!canCreateNatural || !canCreateLegal) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, px: 3, pt: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Tipo de persona del contratista:
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={value}
        onChange={(__, next) => {
          if (!next || next === value) return;
          navigate(next === "JURIDICA" ? "/contracts/legal/new" : "/contracts/new");
        }}
      >
        <ToggleButton value="NATURAL">Persona Natural</ToggleButton>
        <ToggleButton value="JURIDICA">Persona Jurídica</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ContractPersonTypeToggle;
